<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-08 10:46:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-12-26 17:05:35
 * @FilePath: /wemeet-admin-new/src/views/brand/components/addEnterpriseInfo.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer userInfoDrawer"
    :direction="direction"
    :size="size"
    :title="title"
  >
    <el-transfer
      v-model="checkList"
      :data="allEnterPriseList"
      filterable
      :props="transferPop"
      :titles="['未选', '已选']"
    >
      <template #left-empty>
        <el-empty description="No data" :image-size="60" />
      </template>
      <template #right-empty>
        <el-empty description="No data" :image-size="60" />
      </template>
    </el-transfer>
    <div class="demo-drawer__footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSave">提交</el-button>
    </div>
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import { parseTime } from '@/utils/index'
  import { queryAllExhibitor, addGroupExhibitor } from '@/api/enterPriseApi'
  export default defineComponent({
    name: 'EnterpriseListEdit',
    props: {
      meetingCode: {
        type: String,
        default: '',
      },
      groupId: {
        type: String,
        default: '',
      },
    },
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        dialogFormVisible: false,
        direction: 'rtl',
        size: '40%',
        title: '',
        value: [],
        data: [],
        queryForm: {
          pageNum: 1,
          pageSize: 10,
          name: '',
        },
        rules: {
          name: [{ required: true, trigger: 'blur', message: '请输入角色名称' }],
        },
        checkList: [],
        allEnterPriseList: [],
        transferPop: {
          key: 'exhibitorCode',
          label: 'exhibitorName',
        },
      })
      // 打开
      const handleOpen = async (row) => {
        state.title = '添加机构信息'
        state.dialogFormVisible = true
        initData()
      }
      // 关闭
      const handleClose = () => {
        state.form = {}
        state.dialogFormVisible = false
      }

      const initData = async () => {
        const { data } = await queryAllExhibitor({
          meetingCode: props.meetingCode,
          groupId: props.groupId,
        })

        state.checkList = data.map((v) => {
          if (v.status) {
            return v.exhibitorCode
          }
        })

        state.allEnterPriseList = data
      }

      const handleDate = (val) => {
        return parseTime(val)
      }

      const handleSave = async () => {
        try {
          console.log(state.checkList)
          let params = {
            groupId: props.groupId,
            exhibitorCode: state.checkList,
          }
          await addGroupExhibitor(params)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
          handleClose()
          emit('fetch-data')
        } catch (error) {
          proxy.$baseMessage(`操作成功`, 'error', 'vab-hey-message-error')
        }
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchData()
      }

      const handleSelectionChange = (e) => {
        console.log(e)
        state.checkUserList = e
      }
      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        handleDate,
        handleSizeChange,
        handleCurrentChange,
        handleSelectionChange,
        handleSave,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .containerForm {
    height: 85vh;
    overflow-y: auto;
  }
  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }
  .margin-top {
    margin-top: 20px;
  }
</style>
